import { GenericProvider, Provider } from "@/services/data/generic-provider";
import { IUserMetadata } from "./user-metadata.types";
import { baseAPIUrl } from "@/services/utils/utils";

@Provider(`${baseAPIUrl}/user/metadata`)
class UserMetadataProvider extends GenericProvider<IUserMetadata> {}

export const userMetadataProvider = new UserMetadataProvider();
